const routingPrefix = `/beta`;

const prefixRelativeUrl = (url) => {
    // shouldRoute, officialPaths globals set by _ClientSitePrefixing view
    if (
        !window.prevent.shouldRoute ||
        window.prevent.officialPaths.some((path) => url.startsWith(path))
    ) {
        return url;
    }

    return url[0] === `/` ? `${routingPrefix}${url}` : `${routingPrefix}/${url}`;
};

const addcopylinkevent = (selector, callback) => {
    $(selector).click((event) => {
        // Navigator Clipboard API only works on https
        if (location.protocol === 'https:') {
            event.preventDefault();
            copytoclipboard(event);
            callback(event);
        }
    });
};

const copytoclipboard = (e) => {
    var copyText = e.currentTarget.getAttribute('href');

    navigator.clipboard.writeText(copyText);
};

const isFeatureActive = (name) =>
    document.body.getAttribute(`data-activefeatures`).search(new RegExp(`\\b${name}\\b`)) >= 0;

function debounce(func, wait, immediate) {
    var timeout;

    return function executedFunction() {
        var context = this;
        var args = arguments;

        var later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
    };
}

const toValidCssIdentifier = (input) => {
    if (!input || typeof input !== 'string') {
        return 'default-class'; // Fallback for empty or invalid input
    }

    // Replace invalid characters with hyphens
    let result = input.replace(/[^a-zA-Z0-9_-]/g, '-');

    // Ensure it does not start with a digit
    if (/^\d/.test(result)) {
        result = '_' + result;
    }

    return result;
};

export { prefixRelativeUrl, isFeatureActive, debounce, addcopylinkevent, toValidCssIdentifier };
